var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.4366,
    cy: 42.0225,
    r: 42.0225,
    fill: "url(#paint0_linear_2266_15853)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4373 33.6709C40.2224 33.6709 38.0982 34.5508 36.532 36.117C34.9658 37.6831 34.0859 39.8073 34.0859 42.0223C34.0859 44.2372 34.9658 46.3614 36.532 47.9276C38.0982 49.4938 40.2224 50.3736 42.4373 50.3736C44.6522 50.3736 46.7764 49.4938 48.3426 47.9276C49.9088 46.3614 50.7887 44.2372 50.7887 42.0223C50.7887 39.8073 49.9088 37.6831 48.3426 36.117C46.7764 34.5508 44.6522 33.6709 42.4373 33.6709Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4153 16.9688C28.4284 16.9688 24.6049 18.5525 21.7857 21.3717C18.9666 24.1908 17.3828 28.0144 17.3828 32.0012L17.3828 52.0445C17.3828 56.0313 18.9666 59.8549 21.7857 62.674C24.6049 65.4932 28.4284 67.077 32.4153 67.077H52.4586C56.4454 67.077 60.269 65.4932 63.0881 62.674C65.9072 59.8549 67.491 56.0313 67.491 52.0445V32.0012C67.491 28.0144 65.9072 24.1908 63.0881 21.3717C60.269 18.5525 56.4454 16.9688 52.4586 16.9688H32.4153ZM30.745 42.0229C30.745 38.922 31.9768 35.9481 34.1695 33.7554C36.3621 31.5628 39.336 30.3309 42.4369 30.3309C45.5378 30.3309 48.5117 31.5628 50.7043 33.7554C52.897 35.9481 54.1288 38.922 54.1288 42.0229C54.1288 45.1237 52.897 48.0976 50.7043 50.2903C48.5117 52.4829 45.5378 53.7148 42.4369 53.7148C39.336 53.7148 36.3621 52.4829 34.1695 50.2903C31.9768 48.0976 30.745 45.1237 30.745 42.0229ZM54.1288 30.3309H57.4694V26.9904H54.1288V30.3309Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2266_15853",
    x1: 42.4366,
    y1: 0,
    x2: 42.4366,
    y2: 84.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#D42F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD5C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/Insta.dcf7f3aece58835c846ff07562b292b2.svg";
export { ForwardRef as ReactComponent };